import { apiCall } from "./base";

export interface ConversionInputCleanupResponse {
  job_id: string;
  status: "deleted" | "not_found" | "not_applicable" | "unavailable";
}

export interface ConversionInputCleanupOptions {
  keepalive?: boolean;
}

/**
 * Remove the caller-owned temporary conversion input after the user-facing
 * import lifecycle reaches its cleanup terminal.
 */
export const cleanupConversionInput = async (
  jobId: string,
  options: ConversionInputCleanupOptions = {},
): Promise<ConversionInputCleanupResponse> =>
  (await apiCall(
    `/conversion/jobs/${encodeURIComponent(jobId)}/input`,
    { method: "DELETE", keepalive: options.keepalive },
  )) as ConversionInputCleanupResponse;
